import { FORMAT_CATEGORIES_WITH_OTHER, type FormatCategoryWithOther } from "./formatGroups";
import type { FormatSetItem } from "./formatSet";

const FORMAT_CATEGORY_SET = new Set<string>(FORMAT_CATEGORIES_WITH_OTHER);

/** Parses one public category-quantity value such as `vinyl=2`. */
export function parseFormatSetValue(value: string): FormatSetItem | null {
  const match = /^([a-z_]+)=([1-9]\d*)$/.exec(value);
  if (!match) return null;

  const format = match[1];
  const quantity = Number(match[2]);
  if (!format || !FORMAT_CATEGORY_SET.has(format) || !Number.isSafeInteger(quantity)) return null;

  return { format: format as FormatCategoryWithOther, quantity };
}
